import React, { useEffect, useRef, useState } from "react";
import NoDataFound from "../../../../Extra/NoDataFound";
import DownloadExcel from "../../../../Extra/DownloadExcel";

const tableHead = [
  "Sno",
  "DATE",
  "Crew Demanded",
  "Crew Given",
  "Crew Utilized",
  "Crew Wasted",
  "Loco Demanded",
  "Loco Given",
  "Loco Wasted",
  "Remarks",
];
const keyToSum = [
  "CR_DEMANDED",
  "CR_GIVEN",
  "CR_UTILIZED",
  "CR_WASTED",
  "LOCO_DEMANDED",
  "LOCO_GIVEN",
  "LOCO_WASTED",
];

const ROWS_PER_PAGE = 20;

const DayWisePosition = ({ crewData }) => {
  const [sumData, setSumData] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const tableRef = useRef();

  function sumByKeys(arr, keys) {
    return keys.reduce((acc, key) => {
      acc[key] = arr.reduce((sum, obj) => sum + (Number(obj[key]) || 0), 0);
      return acc;
    }, {});
  }

  useEffect(() => {
    const sum = sumByKeys(crewData, keyToSum);
    setSumData([sum]);
    setCurrentPage(1); // reset page when new data comes
  }, [crewData]);

  // Pagination logic
  const totalPages = Math.ceil(crewData.length / ROWS_PER_PAGE);
  const startIndex = (currentPage - 1) * ROWS_PER_PAGE;
  const paginatedData = crewData.slice(startIndex, startIndex + ROWS_PER_PAGE);

  return (
    <div className="m-1">
      <h5
        className="pb-1  "
        style={{ background: "rgba(160, 160, 160, 0.77)" }}
      >
        Day wise
      </h5>
      <div
        style={{ maxHeight: "800px", overflow: "auto" }}
        className="border border-dark papaDivNM"
      >
        <div className="responsive-table">
          <table
            className="table table-hover table-striped m-0 p-0"
            ref={tableRef}
          >
            <thead className="sticky-top">
              <tr className="table-dark">
                {tableHead.map((head, i) => {
                  return <th key={i}>{head}</th>;
                })}
              </tr>
            </thead>
            {crewData.length > 0 && (
              <tbody>
                {paginatedData.map((Obj, index) => {
                  return (
                    <tr key={index}>
                      <td>{startIndex + index + 1}</td>
                      <td>{Obj.CR_DATE.slice(0, 10)}</td>
                      <td>{Obj.CR_DEMANDED}</td>
                      <td>{Obj.CR_GIVEN}</td>
                      <td>{Obj.CR_UTILIZED}</td>
                      <td>{Obj.CR_WASTED}</td>
                      <td>{Obj.LOCO_DEMANDED}</td>
                      <td>{Obj.LOCO_GIVEN}</td>
                      <td>{Obj.LOCO_WASTED}</td>
                      <td>{Obj.REMARKS}</td>
                    </tr>
                  );
                })}
              </tbody>
            )}
            <tfoot className="sticky-bottom table-dark">
              {sumData &&
                sumData.map((Obj, index) => {
                  return (
                    <tr key={index}>
                      <td colSpan={2}>Total</td>
                      <td>{Obj.CR_DEMANDED}</td>
                      <td>{Obj.CR_GIVEN}</td>
                      <td>{Obj.CR_UTILIZED}</td>
                      <td>{Obj.CR_WASTED}</td>
                      <td>{Obj.LOCO_DEMANDED}</td>
                      <td>{Obj.LOCO_GIVEN}</td>
                      <td>{Obj.LOCO_WASTED}</td>
                      <td></td>
                    </tr>
                  );
                })}
            </tfoot>
          </table>

          {/* No data message */}
          {crewData?.length === 0 && <NoDataFound />}
        </div>
      </div>
      {/* Pagination controls */}

      {crewData.length > ROWS_PER_PAGE ? (
        <div className="d-flex justify-content-between align-items-center my-2">
          <button
            className="btn btn-sm btn-dark"
            disabled={currentPage === 1}
            onClick={() => setCurrentPage((p) => p - 1)}
          >
            Previous
          </button>
          <span>
            Page {currentPage} of {totalPages}
          </span>
          <div className="d-flex">
            <button
              className="btn btn-sm btn-dark me-1"
              disabled={currentPage === totalPages}
              onClick={() => setCurrentPage((p) => p + 1)}
            >
              Next
            </button>
            <DownloadExcel
              tableRef={tableRef}
              fileName={`Crew day wise Position `}
            />
          </div>
        </div>
      ) : (
        <DownloadExcel
          tableRef={tableRef}
          fileName={`Crew day wise Position `}
        />
      )}
    </div>
  );
};

export default DayWisePosition;
